import crypto from 'crypto'

export function randomSecret() {
  // Indicate the source via https://github.com/ensdomains/docs/pull/127
  const platformSource = 'b7c4033f' // first 8 bytes of kodex.eth namehash
  return '0x' + platformSource + crypto.randomBytes(28).toString('hex')
}
